import { Box, Card, CardContent, Typography } from '@mui/material';
import type { Market } from '../dataProvider/types';
import type { ExitClicksBand as Band } from './exitClicksModel';
import { ExitClicksTable } from './ExitClicksTable';
import { ExitClicksChart } from './ExitClicksChart';

/**
 * One full-width market band: the leakage leaderboard table and the Recharts
 * leak-volume bar chart beneath it. A band is wholly self-contained per market; a
 * dual-market brand appears as one row here and one row in the other band, never
 * merged. These are counts and a percentage, so there is no currency on this
 * surface.
 */

const MARKET_NAME: Record<Market, string> = {
  uk: 'United Kingdom',
  us: 'United States',
  ie: 'Ireland',
};

export const ExitClicksBand = ({ band }: { band: Band }) => (
  <Card
    variant="outlined"
    data-testid={`ec-band-${band.market}`}
    sx={{ mb: 3 }}
  >
    <CardContent>
      <Typography variant="h6" component="h2" sx={{ mb: 2 }}>
        {MARKET_NAME[band.market]}
      </Typography>

      <ExitClicksTable
        ranked={band.ranked}
        subFloor={band.subFloor}
        medianRate={band.medianRate}
      />

      <Box sx={{ mt: 3 }}>
        <ExitClicksChart rows={band.ranked} />
      </Box>
    </CardContent>
  </Card>
);
